/** Height of the floating bottom nav pill. */
export const MOBILE_NAV_HEIGHT = 80;

/** Gap between the bottom nav and the viewport edge. */
export const MOBILE_NAV_BOTTOM_GAP = 10;

/** Total vertical space reserved for the fixed bottom nav. */
export const MOBILE_BOTTOM_NAV_INSET = MOBILE_NAV_HEIGHT + MOBILE_NAV_BOTTOM_GAP;
